import { Comment } from "types/social-account";
import SocialPostComment from "./SocialPostComment";

interface CommentRepliesProps {
    replies: Comment[];
    onReply: (comment: Comment) => void;
    onDelete: (comment: Comment, reset?: () => void) => void;
    onReplyPrivately: (comment: Comment) => void;
}

const CommentReplies = ({ replies, onReply, onDelete, onReplyPrivately }: CommentRepliesProps) => {
    return (
        <div className="comment-replies">
            {replies.map((reply) => (
                <SocialPostComment onDelete={onDelete} onReply={() => onReply(reply)} onReplyPrivately={() => onReplyPrivately(reply)} key={reply.id} comment={reply} isReply />
            ))}
        </div>
    );
};


export default CommentReplies